module.exports = __webpack_public_path__ + "img/dropbox.5666c8dd.png";